/* src/app/views/auth/components/auth/new-password/new-password.component.scss */
/*# sourceMappingURL=new-password.component.css.map */
